export default __webpack_public_path__ + "static/media/1084.e712a310.png";